export default [
    {
        name: "privacy",
        path: "/docs/privacy",
        component: () => import(/* webpackChunkName: "docs" */ "@/views/docs/PrivacyView.vue"),
    },
    {
        name: "prequalificationTAndC",
        path: "/docs/prequalificationtandc",
        component: () => import(/* webpackChunkName: "docs" */ "@/views/docs/PreQualificationsTermsAndConditionsView.vue"),
    },
    {
        name: "creditReport",
        path: "/docs/creditReport",
        component: () => import(/* webpackChunkName: "docs" */ "@/views/docs/CreditReportView.vue"),
    },
    {
        name: "privacyNotice",
        path: "/docs/privacyNotice",
        component: () => import(/* webpackChunkName: "docs" */ "@/views/docs/PrivacyNoticeView.vue"),
    },
    {
        name: "participatingCreditors",
        path: "/docs/participatingCreditors",
        component: () => import(/* webpackChunkName: "docs" */ "@/views/docs/ParticipatingCreditorsView.vue"),
    },
    {
        name: "arbitrationProvision",
        path: "/docs/arbitrationProvision",
        component: () => import(/* webpackChunkName: "docs" */ "@/views/docs/ArbitrationProvisionView.vue"),
    },
    {
        name: "electronicDisclosuresAndSignatures",
        path: "/docs/electronicDisclosuresAndSignatures",
        component: () => import(/* webpackChunkName: "docs" */ "@/views/docs/ElectronicDisclosuresAndSignaturesView.vue"),
    },
]
